import { render, staticRenderFns } from "./Ribbons.vue?vue&type=template&id=93294a76"
import script from "./Ribbons.vue?vue&type=script&lang=js"
export * from "./Ribbons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports